import { Injectable } from '@angular/core';
import { SettingsLoaderService } from '@supoui/core/services/settings.loader.service';

@Injectable({
  providedIn: 'root'
})
export class SettingsService {
  constructor(private settingsLoaderService: SettingsLoaderService) {}

  getApp(): string {
    return this.settingsLoaderService.configuration.app;
  }

  getSupouiEndpoint(): string {
    return this.settingsLoaderService.configuration.supouiEndpoint;
  }

  isProduction(): boolean {
    return this.settingsLoaderService.configuration.isProduction;
  }

  isTest(): boolean {
    return this.settingsLoaderService.configuration.isTest;
  }

  isNewSupo(): boolean {
    return this.settingsLoaderService.configuration.isNewSupo;
  }

  isLocal(): boolean {
    return !this.isProduction() && !this.isTest();
  }

  getGoogleAPIKey() : string {
    return this.settingsLoaderService.configuration.googleAPIKey;
  }

  getKeycloakSettings() {
    return this.settingsLoaderService.configuration.keycloak;
  }

}
